<div class="dialog-form">
  <h3 class="form-title">Selecione a data para antecipar o fim da vigência</h3>
  
  <div class="form-control">
    <label for="antecipationDate">Data de Antecipação</label>
    <p-calendar 
      id="antecipationDate"
      [(ngModel)]="selectedDate" 
      [minDate]="minDate" 
      [maxDate]="maxDate"
      [showIcon]="true" 
      dateFormat="dd/mm/yy" 
      [monthNavigator]="true" 
      [yearNavigator]="true"
      [yearRange]="'2024:2030'"
      [readonlyInput]="true"
      appendTo="body">
    </p-calendar>
    
    <div class="date-info" *ngIf="minDate && maxDate">
      <small>
        Datas disponíveis: de {{minDate | date: 'dd/MM/yyyy'}} até {{maxDate | date: 'dd/MM/yyyy'}}
      </small>
    </div>
  </div>

  <div class="buttons">
    <button class="easymarine danger" (click)="close()">Cancelar</button>
    <button 
      class="primary easymarine" 
      (click)="save()" 
      [disabled]="isSaveDisabled()">
      Salvar
    </button>
  </div>
</div>